// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionWidth: 300,
		suggestionPosition: 'left',
		suggestionStyle2MainContainerSelector: 'body' // for style2
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
		
		if (jQ('.mfp-wrap').length > 0) {
			jQ(suggestionElement).parent().css({
				'position': 'fixed',
			});
			jQ(suggestionElement).css({
				'overflow-y': 'scroll',
				'height': '300px'
			});
		}
		
		jQ('[aria-label="Blog & Pages"] .ui-menu-item-wrapper').each(function(){
			const itemText = $(this).html().toLowerCase();
			$(this).html(itemText);
		});

		jQ('.boost-pfs-search-suggestion-group[data-group="products"] ul li').each( function() {
			
			let priceCount = $(this).find('.boost-pfs-search-suggestion-product-regular-price').text().length;
			if ( priceCount > 4 ) {
				$(this).addClass('on-top');
			}
		});
	};
})();